import { useTransform, motion, useAnimation } from "motion/react";
import React, { useEffect } from "react";
import { useInView } from "react-intersection-observer";

const ScroolCard = ({ i, v, progress, range, targetScale }) => {
  const scale = useTransform(progress, range, [1, targetScale]);

  const { ref, inView, entry } = useInView({});
  const animation = useAnimation();
  useEffect(() => {
    if (inView) {
      animation.start({
        scale: 0.9,

        transition: {
          duration: 0.5,
          ease: "easeInOut",
        },
      });
    }
    if (!inView) {
      animation.start({
        scale: 1,

        transition: {
          duration: 0.5,
          ease: "easeInOut",
        },
      });
    }
  }, [inView]);

  return (
    <motion.div
      ref={ref}
      animate={animation}
      className={`homeproduct_insidebox z-1`}
      style={{ top: `calc(20% + ${i * 25}px)` }}
    >
      <div className="w-1/3">
        <img src={v.image_url} />
      </div>
      <div className="pr-8 w-2/3">
        <h2>{v.content}</h2>
      </div>
    </motion.div>
  );
};

export default ScroolCard;
